
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hardware/cloudMirrorSystem",
      function () {
        return require("private-next-pages/hardware/cloudMirrorSystem/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hardware/cloudMirrorSystem"])
      });
    }
  